import { IDeliveryDetails } from "./IDeliveryDetails";
import { IDiscounts } from "./IDiscounts";
import { IOrderRow } from "./IOrderRow";
import { IPrice } from "./IPrice";

export interface IOrder {
  _id?: string;
  timestamp?: Date;
  partnerId: string;
  subsidiaryId: string;
  orderCreatorUserName?: string;
  deliveryDetails: IDeliveryDetails;
  /* ISO-639-1 language code */
  languageCode: string;
  /* ISO 4217 -based currency code */
  currencyCode?: string;
  rows: IOrderRow[];
  discounts?: IDiscounts;
  totalSum: IPrice;
  sourceSystem?: string;
  orderNumber?: string;
  orderStatus?: OrderStatus;
  paymentTermsCode?: string;
  projectIdDisabled?: string;
}

export enum OrderStatus {
  DRAFT = "DRAFT",
  WAITING = "WAITING",
  PROCESSING = "PROCESSING",
  READY = "READY",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  PENDING_PREPAYMENT = "PENDING_PREPAYMENT",
  PARTIALLY_SHIPPED = "PARTIALLY_SHIPPED",
  SHIPPED = "SHIPPED",
  CANCELLED = "CANCELLED",
}

export enum HandlingFee {
  sku = "HF1",
}

export enum SurfaceTreatmentFee {
  sku = "ZRAL",
}
